import React from 'react';
import { SystemError } from '..';
import { ISystemError } from '../../interfaces';

interface IErrorBoundaryState {
    hasError: boolean;
    error: Error;
}

export class ErrorBoundary extends React.Component<unknown, IErrorBoundaryState> {
    constructor(props: unknown) {
        super(props);
        this.state = { hasError: false, error: undefined };
    }

    static getDerivedStateFromError(error: Error): IErrorBoundaryState {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error): void {
        console.error('ErrorBoundary:', error);
    }

    render(): React.ReactNode {
        if (this.state.hasError) {
            const systemError: ISystemError = {
                error: this.state.error.name,
                errorMessage: this.state.error.message,
            };

            return <SystemError location={{ state: systemError }} />;
        }

        return this.props.children;
    }
}
